export const EvaluationTypeOptions = {
	ACTIVATION: { value: "ACTIVATION", label: "Evaluate By Activation" },
	REGISTRATION: { value: "REGISTRATION", label: "Evaluate By Registration" },
};
